export const NAME_AVATAR_COLORS = [
  '#4d7c0f',
  '#0B63AF',
  '#9a3412',
  '#26736e',
  '#4B32C3',
  '#0b63af',
  '#9a3412',
  '#154983',
  '#7a5900',
];
